<ll-titulo>Nueva Sesion</ll-titulo>

<sesiones-new *ngIf="planificacion" [planificacion]="planificacion"></sesiones-new>
